import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

const AdminDashboardLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="">
      <div className="row g-0 flex-nowrap">
        {/* Sidebar Component */}
        <AdminSidebar
          sidebarCollapsed={sidebarCollapsed} 
          toggleSidebar={toggleSidebar} 
        />

        {/* Content Area - Will render child routes via Outlet */}
        <div 
          className={`col py-3 px-4 ${sidebarCollapsed ? 'col-md-11' : 'col-md-9 col-xl-10'}`}
          style={{ 
            height: '100vh', 
            overflowY: 'auto',
            marginTop: isDesktop ? '80px' : '0',
            paddingTop: isDesktop ? '0' : '1rem'
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;